// .cle authors use "///" as their own paragraph separator within a single
// block of text (a genus description's "CAP... GILLS... SPORE COLOR..."
// sections, typically) - rendered as one unbroken run otherwise, which
// reads as a wall of text. Splitting it into real paragraphs is presentation
// only, the underlying data keeps the raw text as-is.
//
// Shared by DeterminationKeyViewer.js and DeterminationKeyFlatViewer.js.
export function formatText(text) {
  const parts = text.split('///').map(part => part.trim()).filter(Boolean);
  if (parts.length <= 1) {
    return text;
  }
  return parts.map((part, i) => m("p", {
    key: i
  }, part));
}

// A "link"-type target's value is either a real URL (an internet link, or
// a same-zip file DeterminationKeyContentResource already resolved to one
// server-side) or, for a standalone .cle with nothing to resolve a
// companion-file reference against, the bare filename the .cle itself
// referenced - only the former is ever safe to render as a working link.
export function looksLikeUrl(value) {
  return /^(https?:)?\//.test(value);
}
flarum.reg.add('champis-keys', 'forum/utils/keyText', { formatText: formatText,looksLikeUrl: looksLikeUrl, });